import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HeroUIProvider, ToastProvider } from "@heroui/react"
import { AuthProvider } from './contexts/auth-context'
import App from './App'
import './index.css'
import { HelmetProvider } from 'react-helmet-async'
import { ThemeProvider } from './contexts/theme-context'
import initAnalytics from './analytics'
// import { SSRDataProvider } from './contexts/ssr-data-context'

const helmetContext: any = {}

const ssrData = (window as any).__SSR_DATA__ || null;

const rootEl = document.getElementById('root')!;

// Diagnostic helpers: log bootstrap and surface runtime errors into a visible overlay
console.info('[entry-client] booting client app');

function escapeHtml(s: string) {
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

window.addEventListener('error', (ev) => {
  const msg = ev.error?.message || ev.message || 'Unknown error';
  const stack = ev.error?.stack || '';
  console.error('[entry-client] window error', ev.error || ev.message, ev);
});

window.addEventListener('unhandledrejection', (ev) => {
  const reason = ev.reason;
  console.error('[entry-client] unhandledrejection', reason, ev);
  const msg = reason?.message || String(reason);
  const stack = reason?.stack || '';
});

try {
  createRoot(rootEl).render(
    <React.StrictMode>
      <HelmetProvider context={helmetContext}>
        <BrowserRouter>
            <HeroUIProvider>
              <AuthProvider>
                <ThemeProvider>
                    <App />
                </ThemeProvider>
              </AuthProvider>
            </HeroUIProvider>
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>,
  );
  console.info('[entry-client] render finished');
} catch (err: any) {
  console.error('[entry-client] render threw', err);
}

// Initialize analytics only on client
try {
  initAnalytics();
} catch (e) {
  // ignore analytics init errors
}
